import { useEffect } from 'react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { capitaliseString } from './utils/StringFormatters';

const executeToasts = (toasts) => {
  toasts.forEach(({ type, message }) => {
    const [toastType, toastDuration] = type.split('|');

    const duration = toastDuration === 'infinity' ? Infinity : parseInt(toastDuration, 10) || 6000;

    const options = { duration };

    switch (toastType) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.error(message, options);
        break;
      default:
        toast(message, { type: toastType, ...options });
    }
  });
};

export default function Toast({ messages = [] }) {
  useEffect(() => {
    if (messages.length <= 0) return;

    executeToasts(messages);

    return () => toast.dismiss();
  }, []);

  return (
    <Toaster
      toastOptions={{
        className: 'react-hot-toast',
        blank: {
          style: {
            background: '#6E84A3',
            color: '#fff',
          },
        },
        notice: {
          style: {
            background: '#6E84A3',
            color: '#fff',
          },
          icon: 'ℹ️',
        },
        success: {
          style: {
            background: '#4CAF50',
            color: '#fff',
          },
          icon: '✅',
        },
        warning: {
          style: {
            background: '#FF9800',
            color: '#fff',
          },
          icon: '⚠️',
        },
        delete: {
          style: {
            background: '#DC3C69',
            color: '#fff',
          },
          icon: '🗑️',
        },
        error: {
          style: {
            background: '#DC3C69',
            color: '#fff',
          },
          icon: '🚫',
        },
        loading: {
          style: {
            background: '#6E84A3',
            color: '#fff',
          },
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <div className="toast-content">
              <div className="top-bar">
                <div className="icon">{icon}</div>
                <div className="type">{capitaliseString(t.type)}</div>
                <div className="dismiss-button-container">
                  {t.type !== 'loading' && ( // Optional: Don't show dismiss for loading toasts
                    <button className="dismiss-button" onClick={() => toast.dismiss(t.id)}>
                      <i className="fe fe-x" />
                    </button>
                  )}
                </div>
              </div>
              <div className="message">{message}</div>
            </div>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}
